module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLightItalic.1324b696.eot";